'use client';

import { Navigate } from 'react-router-dom';

/**
 * `/` inside the authenticated app shell: never show the public splash (that UI is only for unauthenticated entry,
 * which renders `Login` directly). Sending logged-in users to the dashboard avoids a stray logo + "Login" button.
 */
export default function Home() {
  return <Navigate to="/app/dashboard" replace />;
}
